import React, {
  useState,
  useRef,
  ReactElement,
  useEffect,
  // useEffect,
  // useCallback,
} from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from 'ionic-ui';
import { useClickOutside } from '../../hooks/useClickOutside';
// import { useIonViewDidEnter, useIonViewWillLeave } from '@ionic/react';

const ionicContextMenuVariants = cva(
  'w-full z-10 rounded-md sm:min-w-32 max-h-[40vh] absolute shadow-md border overflow-auto dashboard-scroller',
  {
    variants: {
      variant: {
        default: 'bg-background dark:bg-background-accent',
        filled: 'bg-gray-100 dark:bg-background-accent',
      },
      size: {
        xs: 'text-xs',
        sm: 'text-sm',
        default: 'text-sm',
        lg: 'text-base',
        xlg: 'text-base',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  }
);

export interface IonicContextMenuProps extends VariantProps<
  typeof ionicContextMenuVariants
> {
  //Style properties
  variant?: 'default' | 'filled';
  size?: 'xs' | 'sm' | 'default' | 'lg' | 'xlg';
  width?: number;

  //Content
  trigger: ReactElement<any>;
  options: { label: string; onClick: () => void }[];

  //Class
  className?: string;
}

export const IonicContextMenu: React.FC<IonicContextMenuProps> = ({
  variant,
  size = 'default',
  // width = 130,
  trigger,
  options,
  className,
}) => {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);
  const { ref, triggerRef } = useClickOutside((e) => {
    if (open && !wrapperRef.current?.contains(e.target as Node)) {
      setOpen(false);
    }
  });

  const Trigger = () => {
    return React.cloneElement(trigger, {
      ref: triggerRef,
      isOpen: open,
      onClick: (e: MouseEvent) => {
        e.stopPropagation();
        setOpen((prev) => !prev);
      },
    });
  };

  useEffect(() => {
    return () => {
      setOpen(false);
    };
  }, []);

  return (
    <div className="contents" ref={wrapperRef}>
      <Trigger />
      <div
        onClick={() => setOpen(false)}
        className={`context-menu ${open ? 'block' : 'hidden'} absolute top-full left-0 w-full h-full bg-transparent`}
      >
        <div
          ref={ref}
          className={cn(ionicContextMenuVariants({ variant, size }), className)}
        >
          {options.map(({ label, onClick }) => {
            return (
              <div
                key={label}
                onClick={(e) => {
                  e.stopPropagation();
                  setOpen(false);
                  onClick();
                }}
                dangerouslySetInnerHTML={{ __html: label }}
                className="cursor-pointer px-3 high-emphasis-text py-2 hover:bg-muted max-w-full truncate"
              ></div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default IonicContextMenu;
